import React, {
    FC,
    useEffect,
    useState,
} from "react";
import {useParams} from "react-router-dom";
import {
    Box,
    Card,
    CircularProgress,
    Divider,
    Typography,
} from "@mui/material";
import {fetchMotorcycleById} from "../../../api/apiService";
import {IMotorcycle} from "../../../interfaces/Interfaces";
import {motorcycleDetailsConfig} from "./motorcycleDetailsConfig";
import {MotorcycleHeader} from "./MotorcycleHeader";
import {MotorcycleDetailsSection} from "./MotorcycleDetailsSection";
import {MotorcycleGallery} from "./gallery/MotorcycleGallery";

export const CatalogueDetails: FC = () => {
    const {id} = useParams<{id: string}>();
    const [motorcycleData, setMotorcycleData] = useState<{
        motorcycle: IMotorcycle | null;
        loading: boolean;
    }>({motorcycle: null, loading: true});
    const splitDetails = (config: typeof motorcycleDetailsConfig) => {
        const basicInfo = config.slice(0, Math.ceil(config.length / 2));
        const additionalInfo = config.slice(Math.ceil(config.length / 2));
        return {basicInfo, additionalInfo};
    };
    useEffect(() => {
        const fetchDetails = async () => {
            if (id) {
                setMotorcycleData({motorcycle: null, loading: true});
                try {
                    const data = await fetchMotorcycleById(parseInt(id, 10));
                    const motorcycle = Array.isArray(data) && data.length > 0 ? data[0] : null;
                    setMotorcycleData({motorcycle, loading: false});
                } catch (error) {
                    console.error("Error fetching motorcycle details:", error);
                    setMotorcycleData({motorcycle: null, loading: false});
                }
            }
        };
        fetchDetails();
    }, [id]);
    const {motorcycle, loading} = motorcycleData;
    if (loading) return <CircularProgress sx={{display: "block", margin: "auto"}}/>;
    if (!motorcycle) return <Typography align="center">No data available</Typography>;
    const {basicInfo, additionalInfo} = splitDetails(motorcycleDetailsConfig);
    return (
        <Card
            sx={{
                margin: "auto",
                padding: 3,
                boxShadow: 3,
                borderRadius: 2,
                mt: 2,
                backgroundColor: theme => theme.palette.card.background,
            }}
        >
            <MotorcycleHeader title={`${motorcycle.makerName} ${motorcycle.modelName}`}/>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: {xs: "column", md: "row"},
                    gap: 3,
                    mb: 3,
                }}
            >
                <Box sx={{flex: 1}}>
                    <MotorcycleGallery motorcycle={motorcycle}/>
                </Box>
                <Box sx={{flex: 1}}>
                    <MotorcycleDetailsSection details={basicInfo} motorcycle={motorcycle}/>
                </Box>
            </Box>
            <Divider sx={{my: 2}}/>
            <MotorcycleDetailsSection details={additionalInfo} motorcycle={motorcycle} isSplit/>
        </Card>
    );
};
